var toggleSearch = function(){
  var body;
  var navButton;
  var nav;
  var billboard;
  var isOpen;

  var _init = function(){
    body = document.body;
    navButton = document.getElementById('toggle-mobile-nav');
    nav = document.getElementById('m-mobile-nav');
    billboard = document.getElementsByClassName('m-banner--billboard')[0];
    isOpen = false;

    navButton.addEventListener('click', _toggleMobileNav);
    window.addEventListener('resize', _handleResize);
  };

  var _handleResize = function(){
    if(window.innerWidth > 969 && isOpen){
      isOpen = !isOpen;
      body.classList.remove('is-mobile-menu-active');  
    }
  };

  var _toggleMobileNav = function(){
    body.classList.toggle('is-mobile-menu-active');

    isOpen = !isOpen;

    if(billboard && isOpen){
      nav.style.top = billboard.clientHeight+'px';
    }

    _removeActiveSearch();
  };

  var _removeActiveSearch = function(){
    if (body.classList.contains('is-search-active')) {
      body.classList.remove('is-search-active');
    }
  }


  return {
    init: _init
  }
}();

if(document.getElementById('toggle-mobile-nav')){
  toggleSearch.init();
}